export default "__VITE_ASSET__DVZBg99M__"